import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const BANNERS_BANNER_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/banners',
        iconClass: 'fas fa-rectangle-ad',
        name: '::Menu:Banners',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Banners',
      },
    ]);
  };
}
